export const UPDATE_APP = "UPDATE_APP";
export const FETCH_REQUEST = "FETCH_REQUEST";
export const FATAL_ERROR = "FATAL_ERROR";

export const SHOW_HIDE_LOADER = "SHOW_HIDE_LOADER";
